{
    "Accessibility Menu": "पहुँचियोग्यता मेनू",
    "Reset settings": "सेटिंग रीसेट करें",
    "Close": "बंद करें",
    "Content Adjustments": "सामग्री समायोजन",
    "Adjust Font Size": "फ़ॉन्ट आकार समायोजित करें",
    "Highlight Title": "शीर्षक को हाइलाइट करें",
    "Highlight Links": "लिंक को हाइलाइट करें",
    "Readable Font": "पढ़ने योग्य फ़ॉन्ट",
    "Color Adjustments": "रंग समायोजन",
    "Dark Contrast": "अंधेरा विरोध",
    "Light Contrast": "प्रकाश विरोध",
    "High Contrast": "उच्च विरोध",
    "High Saturation": "उच्च संतुलन",
    "Low Saturation": "निम्न संतुलन",
    "Monochrome": "एकरंग",
    "Protanopia": "प्रोटानोपिया",
    "Deuteranopia": "ड्यूटेरानोपिया",
    "Tritanopia": "ट्राइटानोपिया",
    "Visual & Navigation Aids": "दृश्य और नेविगेशन सहायता",
    "Additional Tools": "अतिरिक्त उपकरण",
    "Reading Guide": "पढ़ने का गाइड",
    "Stop Animations": "एनिमेशन रोकें",
    "Big Cursor": "बड़ा कर्सर",
    "Screen Reader": "स्क्रीन रीडर",
    "Hide Images": "छवियाँ छिपाएँ",
    "Image Tooltips": "छवि टूलटिप",
    "Page Structure": "पृष्ठ संरचना",
    "Super Focus": "सुपर फ़ोकस",
    "Magnifier": "आवर्धक",
    "Increase Font Size": "फ़ॉन्ट आकार बढ़ाएँ",
    "Decrease Font Size": "फ़ॉन्ट आकार कम करें",
    "Letter Spacing": "अक्षर स्पेसिंग",
    "Line Height": "लाइन की ऊँचाई",
    "Font Weight": "फ़ॉन्ट वेट",
    "Dyslexia Font": "डिस्लेक्सिया फ़ॉन्ट",
    "Language": "भाषा",
    "Open Accessibility Menu": "एक्सेसिबिलिटी मेनू खोलें",
    "Accessibility Profiles": "पहुँचयोग्यता प्रोफ़ाइल",
    "Seizure Safe Profile": "दौरा-सुरक्षित प्रोफ़ाइल",
    "Stops animations and reduces color saturation.": "एनिमेशन रोकता है और रंग संतृप्ति कम करता है।",
    "Blind Profile": "दृष्टिहीन प्रोफ़ाइल",
    "Activates the screen reader for auditory navigation.": "श्रवण नेविगेशन के लिए स्क्रीन रीडर सक्रिय करता है।",
    "Visually Impaired Profile": "दृष्टिबाधित प्रोफ़ाइल",
    "Enhances contrast and readability for low vision.": "कम दृष्टि के लिए विपरीतता और पठनीयता बढ़ाता है।",
    "ADHD Friendly Profile": "ADHD-अनुकूल प्रोफ़ाइल",
    "Reduces distractions for better focus.": "बेहतर एकाग्रता के लिए विकर्षण कम करता है।",
    "Cognitive & Learning Profile": "संज्ञानात्मक और शिक्षण प्रोफ़ाइल",
    "Helpful tools for reading and comprehension.": "पढ़ने और समझने के लिए उपयोगी उपकरण।",
    "Motor Impaired Profile": "गतिशीलता-विकलांग प्रोफ़ाइल",
    "Optimizes the site for keyboard-only navigation.": "साइट को केवल कीबोर्ड नेविगेशन के लिए अनुकूलित करता है।",
    "Headings": "शीर्षक",
    "Landmarks": "लैंडमार्क",
    "Links": "लिंक",
    "Focus element": "तत्व पर फ़ोकस करें",
    "Visit link": "लिंक पर जाएँ"
}